import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Paginator } from 'primereact/paginator';
import { formatDate, getSortIcon, handleFilters } from 'utils/common-functions';
import { IconField } from 'primereact/iconfield';
import { InputText } from 'primereact/inputtext';
import { InputIcon } from 'primereact/inputicon';
import { useNavigate } from 'react-router-dom';
import { routes } from 'utils/routes';
import { Skeleton } from 'primereact/skeleton';
import { _Object } from 'utils/interfaces';
import { useFormik } from 'formik';
import { servicesService } from 'services';
import { SEOHeader } from 'views/components';

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState<_Object>({})
  const [filterData, setFilterData] = useState<_Object>({
    page: 1,
    per_page: 10,
    q: "",
    sort: '-created_at',
  })
  const getServices = async () => {
    setLoading(true);
    try {
      const data = await servicesService.getServices(filterData);

      setServices(data.items);
      setPagination(data.pagination);
    } catch (error) {
      console.error('Error fetching store report:', error);
    } finally {
      setLoading(false);
    }
  };

  const onPageChange = (event: any) => {
    const currentPage = Math.floor(event.first / event.rows) + 1;

    setFilterData((prev) => ({
      ...prev,
      page: currentPage,
      per_page: event.rows,
    }));
  };


  useEffect(() => {
    getServices();
  }, [filterData]);

  const navigate = useNavigate()

  const formikFilter = useFormik({
    initialValues: filterData,
    enableReinitialize: true,
    onSubmit: (values: _Object) => {
      setFilterData((prev) => ({
        ...prev,
        q: values.q.trim(),
        page: 1
      }));
    }
  });

  return (
    <>
      <SEOHeader title="Services" />

      <div className="flex justify-content-between align-items-center">
        <div className="p-inputgroup search-bar col-6">
          <form onSubmit={formikFilter.handleSubmit}>
            <div className='form-group mb-0 mr-2'>
              <Button type='submit' className='search-loading bg-transparent p-0 border-none'
                disabled={loading}>
                {loading && <i className="pi pi-spin pi-spinner"
                  style={{ fontSize: '1rem' }}
                >
                </i>}
              </Button>

              <IconField iconPosition="left">
                <InputIcon className="pi pi-search"> </InputIcon>
                <InputText placeholder="Search"
                  name='q'
                  onChange={formikFilter.handleChange}
                  onBlur={formikFilter.handleBlur}
                  value={formikFilter.values.q} />
              </IconField>

              {filterData.q && <Button type='button'
                onClick={() => {
                  setFilterData((prev) => ({
                    ...prev,
                    q: '',
                    page: 1
                  }))
                }}
                severity="secondary" text className='bg-transparent p-0 border-none absolute top-0 right-0 mr-3'>
                <span className="pi pi-times "> </span>
              </Button>}
            </div>
          </form>

          {pagination?.total_items > 0 &&
            <div className='total-items flex align-items-center text-sm'>
              Total items: {pagination.total_items || ""}
            </div>
          }
        </div>

        <div className="col-4 text-right">
          <Button label="Add New service" icon="pi pi-plus" className="primary" onClick={() => navigate(`${routes.services}/create`)} />
        </div>
      </div>

      <div className="col">
        <div className="card">
          <table className='w-full'>
            <thead>
              <tr>
                <th>#</th>
                <th>Title</th>
                <th>Customer</th>
                <th>Service Number</th>
                <th>Payment Mode</th>
                <th>
                  <button
                    className="btn p-0 border-0"
                    onClick={() => { handleFilters('sort', filterData.sort === '-payment_date' ? 'payment_date' : '-payment_date', setFilterData) }}>
                    Payment Date
                    <i className={`pi ${getSortIcon(filterData.sort.includes('payment_date') ? filterData.sort : '')}`}></i>
                  </button>
                </th>
                {/* <th>Actions</th> */}
              </tr>
            </thead>

            <tbody>
              {loading && Array.from({ length: 5 }).map((_, index) => (
                <tr key={index}>
                  <td><Skeleton height="2rem" borderRadius="1px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                </tr>
              ))}
              {!loading && services?.map((item: _Object, i: number) => (
                <tr>
                  <td>{((filterData.page - 1) * filterData.per_page) + (i + 1)}</td>
                  <td>{item?.title}</td>
                  <td>
                    <strong>Name</strong>: {item?.customer_name || '-'}
                    <br />
                    <strong>Phone</strong>: {item?.customer_phone_number || '-'}
                    <br />
                    <strong>Email</strong>: {item?.customer_email || '-'}
                    <br />
                    <strong>City</strong>: {item?.customer_city || '-'}
                    <br />
                    <strong>State</strong>: {item?.customer_state || '-'}
                  </td>
                  <td>{item?.service_number || '-'}</td>
                  <td>{item?.payment_mode || '-'}</td>
                  <td>{formatDate(item?.payment_date) || '-'}</td>
                  {/* <td>
                    <div>
                      <Button
                        icon="pi pi-pencil"
                        rounded
                        text
                        className="h-auto w-auto bg-transparent p-0 border-noround inline	"
                        onClick={() => editStore(item)}
                        style={{ color: '#959CB6' }}
                      />

                      <Button
                        icon="pi pi-trash"
                        onClick={() => deleteStore(item.storeId)}
                        rounded
                        text
                        className="h-auto w-auto bg-transparent p-0 border-noround inline"
                        style={{ color: 'var(--torch-red)' }}
                      />
                    </div>
                  </td> */}
                </tr>
              ))}
              {!loading && services?.length === 0 && <tr>
                <td colSpan={11}>No available options</td>
              </tr>
              }
            </tbody>
          </table>
          {!loading && pagination?.total_pages > 1 &&
            <Paginator
              first={(filterData.page - 1) * filterData.per_page}
              rows={filterData.per_page}
              totalRecords={pagination.total_items}
              rowsPerPageOptions={[10, 20, 30]}
              onPageChange={onPageChange}
            />
          }
        </div>
      </div>
    </>
  );
};

export default Services;
